import styled from 'styled-components';

const ButtonStyled = styled.a<{ bold: boolean | undefined }>`
  font-style: normal;
  font-weight: ${({ bold }) => (bold ? '700' : '400')};
  font-size: 14px;
  line-height: 12px;
  color: ${({ theme }) => theme.primaryColor};
  cursor: pointer;
  padding-right: 9px;
  min-width: 88px;
`;

export default ButtonStyled;
export { ButtonStyled };
